import { PlaceHolderOptions } from '@Components/TextEditor/TextEditor.types';
import API_URLS from '@Constants/apiUrls.constants';

import { baseApi } from './baseApi.service';

export const tagsApi = baseApi
  .enhanceEndpoints({ addTagTypes: ['TAGS'] })
  .injectEndpoints({
    endpoints: (builder) => ({
      getTags: builder.query<PlaceHolderOptions[], void>({
        query: () => ({
          url: API_URLS.TAGS,
          method: 'GET',
        }),
        providesTags: ['TAGS'],
      }),
    }),
  });

export const { useGetTagsQuery } = tagsApi;
